<template>
  <div>
    <v-list >
    
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">المجموع: {{ cart.total }} دك</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item v-for="item in cart.lineItems" :key="item.id">
        <v-list-item-content>
          <v-list-item-title>{{ item.name | localized }}</v-list-item-title>
          <v-list-item-subtitle class="font-weight-medium" v-if="item.paymentType == 'UserInputAmount'"
            >المبلغ: {{ item.paidAmount }} دك</v-list-item-subtitle
          >
          <v-list-item-subtitle class="font-weight-medium" v-else
            >المبلغ: ({{ item.quantity }} * {{ item.fixedDonationAmount }}) =
            {{ item.quantity * item.fixedDonationAmount }}
            دك</v-list-item-subtitle
          >
        </v-list-item-content>

        <v-list-item-icon>
          <v-btn :loading="deletedItemId == item.id" elevation="0" @click="removeItem(item)"  fab dark small color="error">
            <v-icon dark>  mdi-delete </v-icon>
          </v-btn>       
        </v-list-item-icon>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "CartComponent",

  //********************** */
  components: {},

  //********************** */
  data: () => ({
    isLoadingCart: false,
    showError: false,
    deletedItemId: -1,
  }),

  //********************** */
  computed: {
    ...mapGetters({
      cart: "Cart/cart",
    }),
  },

  //********************** */
  methods: {
    loadData: async function () {
      this.isLoadingCart = true;
      try {
        await this.$store.dispatch("Cart/loadCart");
      } catch (error) {
        this.showError = true;
        setTimeout(() => (this.showError = false), 3000);
        alert(error);
      }
      this.isLoadingCart = false;
    },
    removeItem: async function (item) {
      this.deletedItemId = item.id;
      try {
        let model = {
          cartId: this.cart.id,
          lineItemId: item.id,
        };
        await this.$store.dispatch("Cart/removeItem", model);
      } catch (error) {
        this.showError = true;
        setTimeout(() => (this.showError = false), 3000);
        alert(error);
      }

      this.deletedItemId = -1;
    },
  },

  //*********************** */
  async mounted() {
    await this.loadData();
  },
};
</script>

<style>
</style>